import { api } from '@/api';
import { serializeChatDocumentIds } from './serializeChatDocumentIds';

export interface PostChatDocumentBulkGetUploadRequest {
  chatDocumentIds: string[];
}

export interface ChatDocumentUploadInfo {
  chatDocumentId: string;
  uploadPath: string;
  uploadToken: string;
}

export interface PostChatDocumentBulkGetUploadResponse {
  uploads: ChatDocumentUploadInfo[];
}

const chatDocumentBulkGetUploadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postChatDocumentBulkGetUpload: builder.mutation<
      PostChatDocumentBulkGetUploadResponse,
      PostChatDocumentBulkGetUploadRequest
    >({
      query: ({ chatDocumentIds }) => ({
        url: '/chat/document/bulk-get-upload',
        method: 'POST',
        body: { chatDocumentIds: serializeChatDocumentIds(chatDocumentIds) },
      }),
      /** Mutations don't retry by default, but this one only reads upload URLs, so it's safe to retry. */
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { usePostChatDocumentBulkGetUploadMutation } = chatDocumentBulkGetUploadApi;
